export default {
  //booked information
  book: {
    status: "预约",
    interviewTitle: "面试日期",
    NoteTitle: "备注",
    manageTitle: "管理预约",
    manageDate: "选择日期",
    manageTime: "选择时间",
  },
  // ข้อมูลส่วนบุคคล
  info: {
    title: "个人信息",
    birthdate: "出生日期（日/月/年）",
    gender: "性别",
    address: "地址",
    ethnicity: "种族",
    nationality: "国籍",
    religion: "宗教",
    maritalStatus: "婚姻状况",
    militaryStatus: "兵役状况",
    disabled: "残疾人",
    phone: "电话号码",
    email: "电子邮箱",
    lastUpdated: "最后更新简历时间",
  },

  // ประวัติย่อ
  resume: {
    title: "已上传的简历",
    validText: "有效",
    invalidText: "无效",
  },

  // ความต้องการในการทำงาน
  jobPre: {
    title: "求职意向",
    BusinessTitle: "公司",
    jobType: "工作类型",
    businessSector: "行业类别",
    empType: "雇佣类型",
    jobPosition: "职位",
    expectedSalary: "期望薪资",
    startDate: "可开始工作日期",
    workLocation: "期望工作地点",
    workingStyles: "工作方式",
  },

  // ประวัติการศึกษา
  edu: {
    title: "教育经历",
    institution: "教育机构",
    schoolName: "学校名称",
    schoolMajor: "学习方向",
    grade: "年级",
    universityName: "大学名称",
    degree: "学历",
    faculty: "学院",
    major: "专业",
    startDate: "开始日期",
    endDate: "结束日期",
    gpa: "平均绩点",
  },

  // ประสบการณ์การทำงาน
  workExp: {
    title: "工作/实习经历",
    totalExpYears: "总工作经验",
    noExp: "无经验",
    companyName: "公司名称",
    businessSector: "行业",
    position: "职位",
    jobType: "工作类型",
    empType: "雇佣类型",
    startDate: "开始日期",
    endDate: "结束日期",
    Responsibilities: "工作职责",
    salary: "薪资（泰铢）",
    currentJob: "当前工作",
  },

  // ประสบการณ์การฝึกอบรม
  trainExp: {
    title: "培训经历 / 证书",
    trainingName: "培训名称",
    organization: "主办机构",
    certificateOwner: "证书颁发机构",
    DateOfIssue: "颁发日期",
  },

  // ทักษะ
  skill: {
    title: "技能",
  },

  // ทักษะด้านภาษา
  langSkills: {
    title: "语言",
    tableHead: {
      reading: "阅读",
      writing: "写作",
      speaking: "口语",
      listening: "听力",
    },
    testTitle: "语言能力测试结果",
  },

  // ความสามารถในการขับขี่ยานพาหนะ
  drivingSkill: {
    title: "交通工具使用能力",
    subTitle: "驾驶能力",
    car: "汽车",
    motorcycle: "摩托车",
    other: "其他",
    ownVehicle: "拥有个人交通工具",
  },

  // โครงการ ผลงาน รางวัล และประสบการณ์อื่น ๆ
  project: {
    title: "项目、成果、荣誉及其他经验",
    participationDate: "参与日期",
  },

  //button titles
  btn: {
    back: "个人资料",
    downloadProfile: "下载资料",
    printProfile: "打印资料",
    manageBookConfirm: "确认",
    manageBookCancel: "取消",
  },

  question: {
    title: "问题",
    questionDetail: "需要向机构咨询的问题"
  },

  interviewType: {
    title: "出席方式",
    type: "方式",
    individual: "单独出席 (Individual)",
    group: "团体出席 (Group)",
    amount: "人数",
    unit: "人",
  },
};